// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rb44Kt_a84oMx23AyTtm{justify-content:center;align-items:center;gap:8px;display:flex}.aTqHOQ4mN0EtL_3CNhlq{background:var(--border-neutral-primary);width:1px;height:16px;display:inline-block}.jAbdzIG0qsQrqbv6fYSv{min-width:18px;min-height:32px;margin:-12px;padding:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `rb44Kt_a84oMx23AyTtm`,
	"divider": `aTqHOQ4mN0EtL_3CNhlq`,
	"icon": `jAbdzIG0qsQrqbv6fYSv`
};
export default ___CSS_LOADER_EXPORT___;
